/* Full-cart shipping calculator: quotes the entire current cart and survives cart-section re-renders. */
(function () {
  'use strict';

  function money(value) {
    var number = parseFloat(value);
    if (!isFinite(number)) return String(value || '');
    if (number === 0) return 'Free';
    return '$' + number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function renderRates(root, rates) {
    var results = root.querySelector('[data-ctx-cart-ship-results]');
    if (!results) return;
    var sorted = rates.slice().sort(function (left, right) {
      return parseFloat(left.price) - parseFloat(right.price);
    });
    var cards = sorted.map(function (rate) {
      var name = escapeHtml(rate.name);
      var note = window.ctxRateNote ? window.ctxRateNote(rate.name) : '';
      return '<article class="ctx-cart-shipcalc__rate">'
        + '<div class="ctx-cart-shipcalc__rate-head"><span>' + name + '</span><strong>' + money(rate.price) + '</strong></div>'
        + (note ? '<p>' + escapeHtml(note) + '</p>' : '')
        + '</article>';
    }).join('');
    results.innerHTML = '<div class="ctx-cart-shipcalc__rates">' + cards + '</div>'
      + '<p class="ctx-cart-shipcalc__notice">Estimate only. The final rate and any available delivery choices are confirmed at checkout.</p>';
  }

  document.addEventListener('click', function (event) {
    var submit = event.target.closest && event.target.closest('[data-ctx-cart-ship-submit]');
    if (!submit) return;

    var root = submit.closest('[data-ctx-cart-shipcalc]');
    var state = root && root.querySelector('[data-ctx-cart-ship-state]');
    var zip = root && root.querySelector('[data-ctx-cart-ship-zip]');
    var results = root && root.querySelector('[data-ctx-cart-ship-results]');
    if (!root || !state || !zip || !results) return;

    var province = String(state.value || '').trim();
    var postalCode = String(zip.value || '').trim();
    if (!province || !postalCode) {
      results.innerHTML = '<p class="ctx-cart-shipcalc__status">Select a state and enter a ZIP code to see delivery options.</p>';
      if (!province) state.focus(); else zip.focus();
      return;
    }

    submit.disabled = true;
    results.innerHTML = '<p class="ctx-cart-shipcalc__status">Calculating delivery options for your cart…</p>';
    fetch('/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(postalCode)
      + '&shipping_address[country]=US&shipping_address[province]=' + encodeURIComponent(province))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        submit.disabled = false;
        var rates = data && data.shipping_rates;
        if (!rates || !rates.length) {
          results.innerHTML = '<p class="ctx-cart-shipcalc__status">No online rate is available for that address. Call us and we will quote the right delivery plan.</p>';
          return;
        }
        renderRates(root, rates);
      })
      .catch(function () {
        submit.disabled = false;
        results.innerHTML = '<p class="ctx-cart-shipcalc__status">We could not retrieve rates right now. Try again in a moment or call us for a delivery quote.</p>';
      });
  });
})();
